module.exports = __webpack_public_path__ + "static/media/3DPPA21.4cc15413.jpg";